<template>
    <div :class="{fs: isOpenCamera}">
        <SOSlotModal
            :modal-title="modalTitle"
            :modal-id="modalId"
            @close="!isLoading && back()"
        >
            <template v-slot:modal-body>
                <div class="py-2">
                    <div class="pb-3">
                        <SOInputSelect
                            :title="'Di transfer dari akun'"
                            :selected="formData.idakun_refund"
                            :options="listAkunRefund.map(item => {
                                return {
                                    id: item.idakun,
                                    text: item.nama_akun,
                                }
                            })"
                            @option-selected="data => formData.idakun_refund = data"
                            :required="true"
                            :placeholder="'Pilih Akun...'"
                        />
                        <ErrorMessage
                            label="Akun"
                            class="error"
                            :validation="$v.formData.idakun_refund"
                        />
                    </div>
                    <div v-if="listTransaksi.length" class="p-d-16">
                        <div @click="openListTransaksi()">
                            <div class="f-14">
                                <span class="f-c-midgrey">
                                    transaksi yang dihapus
                                </span>
                                <span class="f-c-blue">
                                    *
                                </span>
                            </div>
                            <div class="p-y-10 p-x-16 border rounded d-flex justify-content-between f-c-midgrey">
                                <span>
                                    {{ formData.idsnapTransaksi || 'Pilih transaksi...' }}
                                </span>
                                <img src="../../../assets/icon-sidebar/chevron-down.svg" />
                            </div>
                        </div>
                        <ErrorMessage
                            label="Akun"
                            class="error"
                            :validation="$v.formData.idakun_refund"
                        />
                    </div>
                    <div
                        id="camera-2-content"
                        :class="{
                            fullScreen: isOpenCamera,
                        }"
                    >
                        <SOUploadNota
                            ref="buktiTransfer"
                            label="Foto Bukti Transfer"
                            is-required
                            id="camera-2"
                            :images="formData.bukti_refund"
                            :camera-open="camera.open"
                            :full-size="camera.fullSize"
                            :preview-img="selectedPreview"
                            @setCamera="onToggleOpen"
                            @setFullSize="onToggleFullSize"
                            @setImages="setImages($event)"
                            @deleteImg="onDeleteImg($event)"
                            @preview="onSelected($event)"
                            @hook:mounted="reloadImage"
                        />
                        <ErrorMessage
                            label="Foto Bukti Transfer"
                            class="error"
                            :validation="$v.formData.bukti_refund"
                        />
                    </div>
                </div>
            </template>
            <template v-slot:modal-footer>
                <div>
                    <SOButton
                        @action="submit()"
                        primary
                        text="Simpan"
                        full
                        :id="`do-refund`"
                        :disable="isLoading"
                        :loading="isLoading"
                    />
                </div>
            </template>
        </SOSlotModal>
        <ModalListTransaksi
            @selected="v => formData.idsnapTransaksi = v"
            ref="modalListTransaksi"
        />
    </div>

</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { moduleName } from "../store/state";
import api from '../api/api'
import conn from "@/store/utils/connection";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOButton from "@/so-components/global/ui/SOButton";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOUploadNota from '@/so-components/global/ui/SOUploadNota.vue';
import { required } from 'vuelidate/lib/validators'
import ErrorMessage from "@/component-items/ErrorMessage";
import ModalListTransaksi from './ModalListTransaksi.vue'

export default {
    name: "RefundCostumer",
    components:{
        SOSlotModal,
        SOButton,
        SOInputSelect,
        SOUploadNota,
        ErrorMessage,
        ModalListTransaksi,
    },
    data() {
        return {
            modalId: "refund-customer",
            modalTitle: "Refund Customer",
            formData: {
                idakun_refund: null,
                bukti_refund: [],
                idsnapTransaksi: null,
            },
            camera: {
                open: false,
                fullSize: false,
            },
            selectedPreview: null,
            isLoading: false,
            isLoadData: false
        }
    },
    computed: {
        ...mapGetters(moduleName, {
            listAkunRefund: "listAkunRefund",
            detailKomplain: "detailKomplain",
            listTransaksi: "listTransaksi",
        }),
        isOpenCamera() {
            return this.camera.open || this.camera.fullSize;
        },
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },  
    validations: {
        formData: {
            idakun_refund: {
                required,
            },
            bukti_refund: {
                required,
            },
            idsnapTransaksi: {
                required,
            }
        }
    },
    methods: {
        ...mapMutations(moduleName, {
            setNeedReload: `setNeedReload`,
        }),
        ...mapActions({
            getRecomendedTransaksi: `${moduleName}/getRecomendedTransaksi`
        }),
        async getData() {
            this.isLoadData = true
            try {
                const id = this.detailKomplain.actual_data.id
                const res = await this.getRecomendedTransaksi(id)
                console.log(res);
                this.isLoadData = false
            } catch (error) {
                this.$toast.error(error)
                this.isLoadData = false
            }
        },
        async back() {
            this.closeModal();
        },
        openListTransaksi() {
            this.$refs.modalListTransaksi.open();
        },
        open() {
            $("#" + this.modalId).modal("show");
            this.getData()
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        async submit() {
            if (this.isInvalid()) {
                this.$toast.error("Mohon lengkapi data yang kosong");
                return;
            }
            this.isLoading = true;
            this.formData.idqris_gagal = this.detailKomplain.actual_data.id;
            const form = new FormData
            form.append("idakun_refund", this.formData.idakun_refund);
            form.append("idqris_gagal", this.formData.idqris_gagal);
            form.append("idsnapTransaksi", this.formData.idsnapTransaksi);
            this.formData.bukti_refund.forEach(element => {
                form.append("bukti_refund", element);
            });
            try {
                const res = await conn.post(api.refundQris, form, conn.contentType.form)
                this.$emit("success", res)
                this.$toast.success('Berhasil refund customer')
                this.setNeedReload(true)
                this.$router.go(-1);
            } catch (error) {
                this.$toast.error(error);
            }
            this.isLoading = false;
        },
        onToggleOpen() {
            this.camera.open = !this.camera.open;
            this.isExpandBiaya = true;
        },
        onToggleFullSize() {
            this.camera.fullSize = !this.camera.fullSize;
            this.isExpandBiaya = true;
        },
        setImages(data) {
            this.formData.bukti_refund = data;
        },
        onDeleteImg(idx) {
            this.formData.bukti_refund.splice(idx, 1);
        },
        onSelected(idx) {
            this.selectedPreview = idx;
        },
        reloadImage() {
            this.$refs.buktiTransfer.handleImages();
        },
        isInvalid() {
            this.$v.formData.bukti_refund.$touch();
            this.$v.formData.idakun_refund.$touch();
            return this.$v.formData.bukti_refund.$invalid || this.$v.formData.idakun_refund.$invalid;
        },
    }
}
</script>
<style scoped>
.fs >>> .bani-modal {
    visibility: hidden;
    height: 100%;
    overflow: hidden    ;
}
.fs >>> .modal-body {
    visibility: visible;
}

.fullScreen {
    padding-left: 0px;
    padding-right: 0px;
    margin-top: -127px;
    margin-left: -20px;
    position: absolute;
    width: 100vw;
    z-index: 200;
}
</style>